export default __webpack_public_path__ + "static/media/87.22336d60.jpeg";